import "./App.css";
import { Tabs } from "@shopify/polaris";
import { BrowserRouter } from "react-router-dom";
import Index from "./pages/index";
import HanderComponen from "./componens/handerComponen";
import { useState, useCallback } from "react";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router>
      <HanderComponen />
        <Index />
    </Router>
  );
}

export default App;
